/* ============================================================
   Quelton — "¿Qué bikini te sienta mejor?": cuestionario de estilo (port del prototipo estilo.js)
   Botón pequeño abajo a la izquierda (no en las fichas de producto) con X: si se cierra, no vuelve en 7 días.
   Pasos: pelo · piel · ojos · silueta · detalles (pecho, piernas, hombros) · estilo (básica → muy icónica)
          · talla · resultado con "Añadir a la cesta".
   Reglas (estudio de colorimetría y siluetas):
   - Color: colorimetría por estaciones (cálido/frío, claro/oscuro, contraste) + afinidades por color de pelo.
   - Mucho pecho: solo tops con sujeción (Sporty / Balconette); nada de triángulo.
   - Poco pecho: estampados y metalizados, que dan volumen.
   - Piernas cortas: braguita tanga, que alarga la pierna.
   - Hombros anchos: nada de bandeau.
   - Estilo: cuanto más icónica se siente, más llamativo el bikini (escala ICONIC por familia, editable abajo).
   Solo se recomiendan bikinis disponibles en su talla: el stock se lee en directo de /products/<handle>.js.
   Textos: <script id="q-estilo-strings"> (snippets/q-estilo.liquid, locales quelton.estilo.*).
   ============================================================ */
(function () {
  'use strict';
  const cfgEl = document.getElementById('q-estilo-strings');
  if (!cfgEl) return;
  let S = {};
  try { S = JSON.parse(cfgEl.textContent); } catch (e) { /* sin textos: se usan las claves */ }
  const T = (k, vars) => {
    let s = S[k] || k;
    if (vars) Object.keys(vars).forEach((v) => { s = s.split(`[${v}]`).join(vars[v]); });
    return s;
  };
  const ROOT = cfgEl.dataset.root || '/';
  const Qx = () => window.Q || {};
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const esc = (s) => String(s ?? '').replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  const img = (url, w) => (url ? `${url}${url.includes('?') ? '&' : '?'}width=${w}` : '');
  const money = (n) => (Qx().money ? Qx().money(n) : Number(n).toLocaleString((window.QTHEME && window.QTHEME.locale) || document.documentElement.lang || 'es-ES', { style: 'currency', currency: (window.QTHEME && window.QTHEME.currency) || 'EUR', minimumFractionDigits: Number.isInteger(Number(n)) ? 0 : 2 }));
  const toast = (m) => (Qx().toast ? Qx().toast(esc(m)) : window.alert(m));
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const KEY = 'quelton-estilo-cerrado';
  const WEEK = 7 * 24 * 3600 * 1000;

  // talla guardada por el buscador de talla del tema (q-theme.js, clave 'quelton-size')
  const Size = {
    get() { if (Qx().Size) return Qx().Size.get(); try { return JSON.parse(localStorage.getItem('quelton-size')) || null; } catch (e) { return null; } },
    set(v) { if (Qx().Size) return Qx().Size.set(v); try { localStorage.setItem('quelton-size', JSON.stringify(v)); } catch (e) { /* sin almacenamiento */ } document.dispatchEvent(new CustomEvent('quelton:size', { detail: v })); },
  };

  // ---------- catálogo: handles reales de la tienda ----------
  // [handle, tipo, familia, forma del top, colores]. Precio, fotos, tallas y stock se leen de la tienda.
  const CATALOG = [
    ['revolve-full-bikini', 'bikini', 'revolve', 'Triángulo', ['Metalizado', 'Rosa', 'Marrón']],
    ['rodeo-full-bikini', 'bikini', 'rodeo', 'Triángulo', ['Rosa']],
    ['howdy-triangl-full-bikini', 'bikini', 'howdy', 'Triángulo', ['Rosa', 'Marrón', 'Blanco', 'Estampado']],
    ['sheriff-full-bikini', 'bikini', 'sheriff', 'Triángulo', ['Blanco', 'Negro', 'Estampado']],
    ['wild-west-full-bikini', 'bikini', 'wild west', 'Triángulo', ['Metalizado', 'Rosa', 'Marrón']],
    ['bikini-completo-the-cowgirl', 'bikini', 'the cowgirl', 'Triángulo', ['Estampado']],
    ['bikini-completo-drama-queen', 'bikini', 'drama queen', 'Triángulo', ['Metalizado']],
    ['bikini-completo-daddy', 'bikini', 'daddy', 'Triángulo', ['Metalizado', 'Bronce', 'Rosa']],
    ['bikini-completo-bronce', 'bikini', 'bronce', 'Triángulo', ['Metalizado', 'Bronce']],
    ['bikini-completo-champan', 'bikini', 'champan', 'Triángulo', ['Metalizado', 'Dorado']],
    ['bikini-completo-aperol', 'bikini', 'aperol', 'Triángulo', ['Metalizado', 'Naranja']],
    ['bikini-completo-cereza', 'bikini', 'cereza', 'Triángulo', ['Metalizado', 'Rojo']],
    ['bikini-completo-lima', 'bikini', 'lima', 'Triángulo', ['Metalizado', 'Verde']],
    ['bikini-completo-yate', 'bikini', 'yate', 'Triángulo', ['Metalizado', 'Azul']],
    ['bikini-completo-the-dreamy-one', 'bikini', 'the dreamy one', 'Triángulo', ['Metalizado']],
    ['bikini-completo-lagoa', 'bikini', 'lagoa', 'Triángulo', []],
    ['bikini-completo-the-friki-one', 'bikini', 'the friki one', 'Triángulo', []],
    ['bikini-completo-the-mean-one', 'bikini', 'the mean one', 'Triángulo', []],
    ['bikini-completo-balconette-daikiri', 'bikini', 'daikiri', 'Balconette', []],
    ['bikini-completo-triangulo-daikiri', 'bikini', 'daikiri', 'Triángulo', []],
    ['bikini-completo-malibu', 'bikini', 'malibu', 'Triángulo', []],
    ['bikini-completo-mai-tai', 'bikini', 'mai tai', 'Triángulo', []],
    ['bikini-completo-pacific-sunshine', 'bikini', 'pacific sunshine', 'Triángulo', []],
    ['bikini-completo-caipirihna', 'bikini', 'caipirinha', 'Triángulo', []],
    ['bikini-completo-banana-cabana', 'bikini', 'banana cabana', 'Triángulo', []],
    ['bikini-completo-banana-cabana-1', 'bikini', 'banana cabana', 'Triángulo', []],
    // tops con sujeción y su braguita a juego (para mucho pecho / silueta "más pecho")
    ['top-sporty-howdy-solo-incluye-el-top', 'top', 'howdy', 'Sporty', ['Rosa', 'Marrón', 'Blanco', 'Estampado']],
    ['top-sporty-banana-cabana', 'top', 'banana cabana', 'Sporty', ['Rosa', 'Rojo', 'Estampado']],
    ['top-balconette-banana-cabana-solo-incluye-top', 'top', 'banana cabana', 'Balconette', ['Rosa', 'Rojo', 'Estampado']],
    ['top-balconette-daikiri-solo-incluye-top', 'top', 'daikiri', 'Balconette', ['Rosa', 'Estampado']],
    ['bottom-howdy-solo-incluye-bottom', 'braguita', 'howdy', '', ['Rosa', 'Marrón', 'Blanco', 'Estampado']],
    ['braguita-banana-cabana-solo-incluye-bottom', 'braguita', 'banana cabana', '', ['Rosa', 'Rojo', 'Estampado']],
    ['braguita-daikiri-solo-incluye-bottom', 'braguita', 'daikiri', '', ['Rosa']],
  ];
  const BESTSELLERS = ['howdy-triangl-full-bikini', 'bikini-completo-champan', 'bikini-completo-daddy', 'bikini-completo-bronce', 'revolve-full-bikini', 'bikini-completo-cereza', 'bikini-completo-yate', 'wild-west-full-bikini', 'sheriff-full-bikini', 'bikini-completo-aperol'];

  // ---------- productos en directo ----------
  const SIZE_ORDER = ['XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL'];
  const sortValues = Qx().sortValues || ((a, b) => {
    const ia = SIZE_ORDER.indexOf(String(a).toUpperCase()), ib = SIZE_ORDER.indexOf(String(b).toUpperCase());
    if (ia > -1 && ib > -1) return ia - ib;
    if (ia > -1) return -1;
    if (ib > -1) return 1;
    return String(a).localeCompare(String(b), 'es');
  });
  function optionMeta(name) {
    const n = name.toLowerCase();
    const part = /top/.test(n) ? 'top' : /braguita|bottom/.test(n) ? 'bottom' : 'single';
    const kind = /estilo|forma|variante|style|shape|variant/.test(n) ? 'style' : /title|denominaci/.test(n) ? 'none' : 'size';
    return { part, kind };
  }
  function parseProduct(j, row) {
    const names = (j.options || []).map((o) => (typeof o === 'string' ? o : o.name));
    const v = (j.variants || []).map((x) => [x.id, [x.option1, x.option2, x.option3], x.price / 100, (x.compare_at_price || 0) / 100, x.available ? 1 : 0]);
    const p = {
      handle: row[0], k: row[1], fam: row[2], shape: row[3], col: row[4],
      t: j.title, img: (j.images || []).map((u) => (u && u.startsWith('//') ? `https:${u}` : u)).filter(Boolean), v,
    };
    p.options = names.map((name, index) => ({ name, index, ...optionMeta(name) })).filter((o) => o.kind !== 'none');
    p.options.forEach((o) => { o.values = [...new Set(v.map((x) => x[1][o.index]).filter(Boolean))].sort(sortValues); });
    return p;
  }
  const PRODUCTS = {};
  let loading = null;
  function loadAll() {
    if (loading) return loading;
    loading = Promise.allSettled(CATALOG.map((row) => fetch(`${ROOT}products/${row[0]}.js`, { headers: { Accept: 'application/json' } })
      .then((r) => (r.ok ? r.json() : null))
      .then((j) => { if (j && j.variants) PRODUCTS[row[0]] = parseProduct(j, row); })));
    return loading;
  }
  const productUrl = (h) => `${ROOT}products/${encodeURIComponent(h)}`;
  const all = () => CATALOG.map((r) => PRODUCTS[r[0]]).filter(Boolean);
  const available = (p) => p && p.v.some((v) => v[4]);
  function findVariant(p, sel) {
    return p.v.find((v) => p.options.every((o) => sel[o.index] === undefined || v[1][o.index] === sel[o.index]));
  }
  function valueAvailable(p, sel, opt, value) {
    const test = { ...sel, [opt.index]: value };
    return p.v.some((v) => v[4] && p.options.every((o) => test[o.index] === undefined || v[1][o.index] === test[o.index]));
  }
  const cleanTitle = (s) => String(s || '').replace(/\s*\(.*?\)/g, '').replace(/\s*[-–]?\s*(solo incluye|only includes?).*$/i, '').trim();

  // ---------- opciones ----------
  // fav: colores que la colorimetría asocia a cada rasgo (se suman)
  const HAIR = [
    { id: 'rubio', c: '#E3C58A', warm: 0, fav: ['Azul', 'Rojo', 'Rosa'] },
    { id: 'castano', c: '#7A4A2C', warm: 1, fav: ['Bronce', 'Dorado', 'Verde', 'Naranja'] },
    { id: 'moreno', c: '#241915', warm: -1, dark: true, fav: ['Rojo', 'Blanco', 'Negro', 'Azul'] },
    { id: 'pelirrojo', c: '#B3532B', warm: 2, fav: ['Verde', 'Dorado', 'Bronce', 'Marrón'] },
  ].map((o) => ({ ...o, label: T(`hair_${o.id}`) }));
  const SKIN = [
    { id: 'muy-clara', key: 'muy_clara', c: '#F6DFCF', warm: -1, depth: 0 },
    { id: 'clara', key: 'clara', c: '#EBC4A6', warm: 0, depth: 1 },
    { id: 'media', key: 'media', c: '#CF9E78', warm: 1, depth: 2 },
    { id: 'morena', key: 'morena', c: '#A4704C', warm: 1, depth: 3 },
    { id: 'oscura', key: 'oscura', c: '#68412A', warm: 0, depth: 4 },
  ].map((o) => ({ ...o, label: T(`skin_${o.key}`) }));
  const EYES = [
    { id: 'azules', c: '#7EA3C6', warm: -1, fav: ['Azul'] },
    { id: 'verdes', c: '#738F57', warm: 1, fav: ['Verde', 'Rosa'] },
    { id: 'miel', c: '#A97A3B', warm: 1, fav: ['Dorado', 'Bronce'] },
    { id: 'marrones', c: '#4A2E1F', warm: 0, fav: [] },
  ].map((o) => ({ ...o, label: T(`eyes_${o.id}`) }));
  // siluetas: anchos (medio cuerpo) de hombros, pecho, cintura y cadera
  const BODY = [
    { id: 'reloj', s: [17, 20, 8, 20] },
    { id: 'pecho', s: [22, 23, 14, 12] },
    { id: 'cadera', s: [12, 12, 10, 23] },
    { id: 'recto', s: [15, 15, 15, 15] },
  ].map((o) => ({ ...o, label: T(`body_${o.id}`), sub: T(`body_${o.id}_sub`) }));
  const DETAILS = [
    { key: 'busto', opts: ['poco', 'medio', 'mucho'] },
    { key: 'piernas', opts: ['cortas', 'normales', 'largas'] },
    { key: 'hombros', opts: ['estrechos', 'normales', 'anchos'] },
  ];
  const STYLE_LEVELS = [1, 2, 3, 4, 5].map((n) => ({ n, label: T(`level_${n}`), text: T(`level_${n}_text`) }));
  // Escala de "icónico" por familia (1 = básico · 5 = muy llamativo). Reyes puede reordenarla.
  const ICONIC = {
    champan: 1, bronce: 1, revolve: 2, daddy: 2, 'the mean one': 2, rodeo: 3, yate: 3, sheriff: 3,
    howdy: 4, 'wild west': 4, lima: 4, 'mai tai': 4, aperol: 5, cereza: 5,
  };
  const iconicOf = (p) => ICONIC[p.fam] || (/(Estampado|Rojo|Naranja|Verde)/.test((p.col || []).join(' ')) ? 4 : (p.col || []).some((c) => ['Negro', 'Marrón', 'Dorado', 'Bronce', 'Blanco'].includes(c)) ? 1 : 3);

  // ---------- colorido → colores que más favorecen ----------
  function palette(a) {
    const warm = a.hair.warm + a.skin.warm + a.eyes.warm;
    const depth = a.skin.depth;
    const contrast = a.hair.dark && depth <= 1;
    const fav = {};
    const add = (cols, n) => cols.forEach((c) => (fav[c] = (fav[c] || 0) + n));
    if (warm > 0) add(['Dorado', 'Bronce', 'Naranja', 'Verde', 'Marrón'], 2);
    else if (warm < 0) add(['Azul', 'Rosa', 'Rojo', 'Blanco', 'Negro', 'Morado'], 2);
    else add(['Rosa', 'Rojo', 'Azul', 'Verde', 'Dorado'], 1);
    add(a.hair.fav, 2);
    add(a.eyes.fav, 1);
    if (depth >= 3) add(['Blanco', 'Naranja', 'Dorado', 'Verde', 'Azul', 'Rosa', 'Rojo'], 2);
    else if (depth === 2) add(['Bronce', 'Dorado', 'Rojo', 'Verde', 'Naranja'], 1);
    else add(['Azul', 'Rojo', 'Rosa'], 1);
    add(['Metalizado'], depth >= 2 ? 1 : 0);
    if (contrast) add(['Negro', 'Rojo', 'Blanco', 'Azul'], 2);
    return { fav, warm, depth, contrast };
  }
  const colorWord = (c) => {
    const k = `col_${c.toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '')}`;
    return S[k] || c.toLowerCase();
  };
  const toneText = (pal) => ({ t: T(pal.warm > 0 ? 'tone_warm' : pal.warm < 0 ? 'tone_cool' : 'tone_neutral'), d: T(`depth_${pal.depth}`) });

  // ---------- tallas (tabla del tema si existe; si no, la oficial de Quelton) ----------
  const CHART = (window.QTHEME && Array.isArray(window.QTHEME.sizeChart) && window.QTHEME.sizeChart.length) ? window.QTHEME.sizeChart : [
    { size: 'XS', pecho: 84, cintura: 64, cadera: 92 },
    { size: 'S', pecho: 89, cintura: 68, cadera: 97 },
    { size: 'M', pecho: 94, cintura: 72, cadera: 102 },
    { size: 'L', pecho: 100, cintura: 78, cadera: 108 },
  ];
  const BRA = { 70: 'XS', 75: 'XS', 80: 'S', 85: 'S', 95: 'M', 100: 'L' };
  const JEANS = { 32: 'XS', 36: 'S', 38: 'M', 40: 'L', 42: 'L' };
  const pickSize = (k, v) => (CHART.find((r) => v < r[k]) || CHART[CHART.length - 1]).size;

  // ---------- reglas de silueta ----------
  function bodyRules(a) {
    const why = [T(`rule_${a.body.id}`)];
    let style = { reloj: 'Tanga', pecho: 'Básica', cadera: 'Básica', recto: 'Tanga' }[a.body.id];
    if (a.piernas === 'cortas') { style = 'Tanga'; why.push(T('rule_legs_short')); }
    if (a.piernas === 'largas' && style === 'Básica') why.push(T('rule_legs_long'));
    const supportOnly = a.busto === 'mucho';
    if (supportOnly) why.push(T('rule_bust_full'));
    if (a.busto === 'poco') why.push(T('rule_bust_small'));
    if (a.hombros === 'anchos') why.push(T('rule_shoulders'));
    return { style, why, supportOnly };
  }

  // ---------- recomendación ----------
  const styleLabel = (v) => (/tanga|thong|brazil/i.test(v) ? 'Tanga' : /basic|básic|classic/i.test(v) ? 'Básica' : /lazo|tie/i.test(v) ? 'Con lazos' : v);
  const styleName = (s) => (s === 'Tanga' ? T('style_tanga') : s === 'Básica' ? T('style_basica') : s);
  function sizeSel(p, sizes, style) {
    const s = {};
    for (const o of p.options) {
      if (o.values.length === 1) { s[o.index] = o.values[0]; continue; }
      if (o.kind === 'size') {
        const want = o.part === 'bottom' || p.k === 'braguita' ? sizes.bottom : sizes.top;
        if (!o.values.includes(want)) return null;
        s[o.index] = want;
      } else {
        s[o.index] = o.values.find((v) => styleLabel(v) === style) || o.values.find((v) => valueAvailable(p, s, o, v));
      }
    }
    const v = findVariant(p, s);
    return v && v[4] ? { sel: s, variant: v } : null;
  }
  function score(p, a, pal) {
    let n = (p.col || []).reduce((t, c) => t + (pal.fav[c] || 0), 0);
    n += 6 - Math.abs(iconicOf(p) - a.estilo) * 2.5;
    const printed = (p.col || []).includes('Estampado'), shiny = (p.col || []).includes('Metalizado');
    if (a.busto === 'poco' && (printed || shiny)) n += 2;
    if (a.busto === 'mucho' && printed) n -= 1;
    if (a.hombros === 'anchos' && /bandeau|bandó/i.test(`${p.shape} ${p.t}`)) n -= 100;
    if (BESTSELLERS.includes(p.handle)) n += 0.5;
    return n;
  }
  function recommend(a) {
    const pal = palette(a);
    const rules = bodyRules(a);
    const picks = [];
    if (rules.supportOnly || a.body.id === 'pecho') {
      all().filter((p) => p.k === 'top' && ['Sporty', 'Balconette'].includes(p.shape) && available(p)).forEach((top) => {
        const t = sizeSel(top, a.sizes, rules.style);
        if (!t) return;
        const bottom = all().find((x) => x.k === 'braguita' && x.fam === top.fam && available(x));
        const b = bottom && sizeSel(bottom, a.sizes, rules.style);
        if (!b) return;
        picks.push({ kind: 'combo', title: `${cleanTitle(top.t)} + ${cleanTitle(bottom.t)}`, price: t.variant[2] + b.variant[2],
          score: score(top, a, pal) + 4, items: [{ p: top, ...t }, { p: bottom, ...b }], shape: top.shape });
      });
    }
    if (!rules.supportOnly) {
      all().filter((p) => p.k === 'bikini' && available(p)).forEach((p) => {
        const r = sizeSel(p, a.sizes, rules.style);
        if (!r) return;
        picks.push({ kind: 'bikini', title: p.t, price: r.variant[2], score: score(p, a, pal), items: [{ p, ...r }], shape: p.shape });
      });
    }
    picks.sort((x, y) => y.score - x.score);
    return { pal, rules, picks: picks.slice(0, 4) };
  }

  // ---------- silueta (SVG dibujado a partir de las medidas) ----------
  function silhouette([sh, bu, wa, hi]) {
    const cx = 40;
    const side = (k) => `M${cx - 5 * k},22 C${cx - 5 * k},26 ${cx - sh * k},26 ${cx - sh * k},31 C${cx - sh * k},36 ${cx - bu * k},38 ${cx - bu * k},45 C${cx - bu * k},52 ${cx - wa * k},54 ${cx - wa * k},60 C${cx - wa * k},66 ${cx - hi * k},70 ${cx - hi * k},77 C${cx - hi * k},86 ${cx - hi * 0.7 * k},96 ${cx - 7 * k},112`;
    const mirror = (d) => d.replace(/(\d+(?:\.\d+)?),/g, (m, x) => `${(2 * cx - Number(x)).toFixed(1)},`);
    const left = side(1);
    return `<svg viewBox="0 0 80 118" width="96" height="142" fill="none" aria-hidden="true">
      <circle cx="40" cy="11" r="8" stroke="currentColor" stroke-width="1.3"/>
      <path d="${left}" stroke="currentColor" stroke-width="1.3" stroke-linecap="round"/>
      <path d="${mirror(left)}" stroke="currentColor" stroke-width="1.3" stroke-linecap="round"/>
      <path d="M${cx - bu + 4},44 q${bu - 4},6 ${2 * bu - 8},0" stroke="var(--accent)" stroke-width="1.6" stroke-linecap="round"/>
      <path d="M${cx - hi + 5},74 q${hi - 5},9 ${2 * hi - 10},0" stroke="var(--accent)" stroke-width="1.6" stroke-linecap="round"/>
    </svg>`;
  }

  // ---------- interfaz ----------
  const STEPS = ['pelo', 'piel', 'ojos', 'cuerpo', 'detalles', 'estilo', 'talla', 'resultado'];
  const ans = { busto: 'medio', piernas: 'normales', hombros: 'normales', estilo: 3 };
  let step = 0, sizeMode = 'medidas', current = 0, styleChoice = null, rec = null;

  const modal = document.createElement('div');
  modal.className = 'sq';
  modal.setAttribute('role', 'dialog');
  modal.setAttribute('aria-modal', 'true');
  modal.setAttribute('aria-label', T('dialog_label'));
  modal.innerHTML = `<div class="sq__overlay" data-sq-close></div>
    <div class="sq__box">
      <div class="sq__top">
        <button class="sq__back" type="button" data-sq-back aria-label="${esc(T('back'))}">←</button>
        <div class="sq__progress" aria-hidden="true"><span data-sq-bar></span></div>
        <button class="sq__close" type="button" data-sq-close aria-label="${esc(T('close'))}">✕</button>
      </div>
      <div class="sq__body" data-sq-body aria-live="polite"></div>
    </div>`;
  document.body.appendChild(modal);
  const body = $('[data-sq-body]', modal);

  const optionGrid = (key, list, extra = '') => `<div class="sq__opts ${extra}">${list.map((o) => `
      <button type="button" class="sq__opt" data-sq-pick="${key}" data-id="${o.id}" aria-pressed="${!!(ans[key] && ans[key].id === o.id)}">
        ${o.s ? silhouette(o.s) : `<i class="sq__dot" style="background:${o.c}"></i>`}
        <b>${esc(o.label)}</b>${o.sub ? `<small>${esc(o.sub)}</small>` : ''}
      </button>`).join('')}</div>`;

  const loadingHTML = () => `<p class="sq__loading">${esc(T('loading'))}</p>`;
  // bikinis de ejemplo para cada nivel de estilo (los disponibles de esa escala)
  function styleExamples(n) {
    if (!loaded) return '';
    return all().filter((p) => p.k === 'bikini' && available(p) && p.img[0])
      .sort((x, y) => Math.abs(iconicOf(x) - n) - Math.abs(iconicOf(y) - n)).slice(0, 3)
      .map((p) => `<span><img src="${esc(img(p.img[0], 240))}" alt="" width="240" height="320" loading="lazy">${esc(p.t.replace(/^(Bikini Completo|Full Bikini)\s*/i, ''))}</span>`).join('');
  }
  let loaded = false;
  function whenLoaded(stepName) {
    if (loaded) return true;
    loadAll().then(() => { loaded = true; if (STEPS[step] === stepName && modal.classList.contains('is-open')) render(); });
    return false;
  }

  function render() {
    const name = STEPS[step];
    $('[data-sq-bar]', modal).style.width = `${((step + 1) / STEPS.length) * 100}%`;
    $('[data-sq-back]', modal).style.visibility = step > 0 ? 'visible' : 'hidden';
    const head = (k, t, p) => `<p class="sq__kicker">${esc(T('step', { n: step + 1, total: STEPS.length }))} · ${esc(k)}</p><h2 class="sq__title">${esc(t)}</h2>${p ? `<p class="sq__lead">${esc(p)}</p>` : ''}`;
    if (name === 'pelo') body.innerHTML = head(T('group_color'), T('hair_title'), T('hair_lead')) + optionGrid('hair', HAIR);
    if (name === 'piel') body.innerHTML = head(T('group_color'), T('skin_title'), T('skin_lead')) + optionGrid('skin', SKIN, 'sq__opts--5');
    if (name === 'ojos') body.innerHTML = head(T('group_color'), T('eyes_title')) + optionGrid('eyes', EYES);
    if (name === 'cuerpo') body.innerHTML = head(T('group_body'), T('body_title'), T('body_lead')) + optionGrid('body', BODY, 'sq__opts--body');
    if (name === 'detalles') {
      body.innerHTML = head(T('group_body'), T('details_title'), T('details_lead')) + DETAILS.map((d) => `
        <div class="sq__row"><p>${esc(T(d.key))}</p><div class="sq__seg">${d.opts.map((v) => `<button type="button" data-sq-detail="${d.key}" data-val="${v}" aria-pressed="${ans[d.key] === v}">${esc(T(`${d.key}_${v}`))}</button>`).join('')}</div></div>`).join('') +
        `<button type="button" class="sq__next" data-sq-nextstep>${esc(T('next'))}</button>`;
    }
    if (name === 'estilo') {
      whenLoaded('estilo');
      const lv = STYLE_LEVELS[ans.estilo - 1];
      body.innerHTML = head(T('group_style'), T('style_title'), T('style_lead')) + `
        <div class="sq__style">
          <input type="range" min="1" max="5" step="1" value="${ans.estilo}" data-sq-estilo aria-label="${esc(T('style_aria'))}" style="--p:${(ans.estilo - 1) * 25}%">
          <div class="sq__style-ends"><span>${esc(T('style_end_1'))}</span><span>${esc(T('style_end_2'))}</span><span>${esc(T('style_end_3'))}</span></div>
          <p class="sq__style-label"><b data-sq-estilo-label>${esc(lv.label)}</b><span data-sq-estilo-text>${esc(lv.text)}</span></p>
          <div class="sq__style-examples" data-sq-estilo-ex>${styleExamples(ans.estilo)}</div>
        </div>
        <button type="button" class="sq__next" data-sq-nextstep>${esc(T('next'))}</button>`;
    }
    if (name === 'talla') renderSize(head);
    if (name === 'resultado') {
      if (!whenLoaded('resultado')) { body.innerHTML = head(T('group_result'), T('result_title')) + loadingHTML(); return; }
      renderResult(head);
    }
  }

  function renderSize(head) {
    const saved = Size.get();
    const opt = (v, l) => `<option value="${v}">${l}</option>`;
    body.innerHTML = head(T('group_size'), T('size_title'), T('size_lead')) + `
      ${saved && saved.top && saved.bottom ? `<button type="button" class="sq__saved" data-sq-saved>${esc(T('size_saved'))} <b>${esc(T('top'))} ${esc(saved.top)} · ${esc(T('bottom'))} ${esc(saved.bottom)}</b></button><p class="sq__or">${esc(T('size_or'))}</p>` : ''}
      <div class="sq__tabs" role="tablist">
        <button type="button" role="tab" aria-selected="${sizeMode === 'medidas'}" data-sq-mode="medidas">${esc(T('tab_measures'))}</button>
        <button type="button" role="tab" aria-selected="${sizeMode === 'ropa'}" data-sq-mode="ropa">${esc(T('tab_clothes'))}</button>
      </div>
      ${sizeMode === 'medidas' ? `
        <div class="sq__sliders">
          ${[['pecho', T('bust'), 70, 115, 88], ['cintura', T('waist'), 55, 100, 68], ['cadera', T('hips'), 80, 120, 96]].map(([k, l, mn, mx, d]) => `
          <label class="sq__slider"><span>${esc(l)}<output data-sq-out="${k}">${d} cm</output></span>
            <input type="range" min="${mn}" max="${mx}" value="${d}" data-sq-range="${k}"></label>`).join('')}
        </div>` : `
        <div class="sq__selects">
          <label>${esc(T('bra'))}<select data-sq-bra>${opt('', esc(T('choose')))}${opt(70, '65 / 70')}${opt(75, '75')}${opt(80, '80')}${opt(85, '85 / 90')}${opt(95, '90 / 95')}${opt(100, '95 / 100')}</select></label>
          <label>${esc(T('jeans'))}<select data-sq-jeans>${opt('', esc(T('choose')))}${opt(32, '32 / 34')}${opt(36, '36')}${opt(38, '38')}${opt(40, '40')}${opt(42, '42')}</select></label>
        </div>`}
      <table class="sq__table"><thead><tr><th>${esc(T('size'))}</th><th>${esc(T('bust'))}</th><th>${esc(T('waist'))}</th><th>${esc(T('hips'))}</th></tr></thead><tbody>
        <tr><td>XS</td><td>78–84</td><td>60–64</td><td>86–92</td></tr><tr><td>S</td><td>84–89</td><td>64–68</td><td>92–97</td></tr>
        <tr><td>M</td><td>89–94</td><td>68–72</td><td>97–102</td></tr><tr><td>L</td><td>94–100</td><td>72–78</td><td>102–108</td></tr></tbody></table>
      <button type="button" class="sq__next" data-sq-calc>${esc(T('calc'))}</button>`;
  }

  function renderResult(head) {
    rec = recommend(ans);
    if (!rec.picks.length) {
      const sporty = rec.rules.supportOnly;
      const href = sporty ? (cfgEl.dataset.shopTops || `${ROOT}collections/tops-o-sujetadores`) : (cfgEl.dataset.shopAll || `${ROOT}collections/all`);
      body.innerHTML = head(T('group_result'), T(sporty ? 'empty_sporty_title' : 'empty_title')) + `
        <p class="sq__lead">${esc(T(sporty ? 'empty_sporty_text' : 'empty_text'))}</p>
        <a class="sq__next" href="${esc(href)}">${esc(T(sporty ? 'empty_sporty_cta' : 'empty_cta'))}</a>
        <button type="button" class="sq__restart" data-sq-restart>${esc(T('restart'))}</button>`;
      return;
    }
    const pick = rec.picks[current] || rec.picks[0];
    const tone = toneText(rec.pal);
    const fav = Object.entries(rec.pal.fav).sort((x, y) => y[1] - x[1]).map(([c]) => c);
    const matched = fav.filter((c) => c !== 'Metalizado' && pick.items.some((i) => (i.p.col || []).includes(c))).slice(0, 2).map(colorWord);
    const lv = STYLE_LEVELS[ans.estilo - 1];
    const style = styleChoice || rec.rules.style;
    pick.items.forEach((it) => {
      const so = it.p.options.find((o) => o.kind === 'style' && o.values.length > 1);
      if (!so) return;
      const v = so.values.find((x) => styleLabel(x) === style);
      if (v && valueAvailable(it.p, { ...it.sel, [so.index]: undefined }, so, v)) { it.sel[so.index] = v; it.variant = findVariant(it.p, it.sel); }
    });
    const styleOpt = pick.items.map((it) => it.p.options.find((o) => o.kind === 'style' && o.values.length > 1)).find(Boolean);
    const okAll = pick.items.every((it) => it.variant && it.variant[4]);
    const total = pick.items.reduce((n, it) => n + (it.variant ? it.variant[2] : 0), 0);
    const url = productUrl(pick.items[0].p.handle);
    const toneLine = esc(T('why_tone', { tone: '\u0001', skin: '\u0002' })).replace('\u0001', `<b>${esc(tone.t)}</b>`).replace('\u0002', esc(tone.d));
    const colorsLine = matched.length ? esc(T('why_colors', { colors: '\u0001' })).replace('\u0001', `<b>${esc(matched.join(` ${T('and')} `))}</b>`) : '';
    body.innerHTML = head(T('group_result'), T('result_title')) + `
      <div class="sq__result">
        <a class="sq__img${pick.kind === 'combo' ? ' sq__img--duo' : ''}" href="${esc(url)}">${pick.items.map((it) => `<img src="${esc(img(it.p.img[0], 700))}" alt="${esc(it.p.t)}" width="700" height="933">`).join('')}</a>
        <div class="sq__info">
          <h3>${esc(pick.title)}</h3>
          <ul class="sq__why">
            <li>${toneLine}${colorsLine}.</li>
            <li>${esc(T('why_style'))} <b>${esc(lv.label.toLowerCase())}</b>. ${esc(lv.text)}</li>
            ${rec.rules.why.map((w) => `<li>${esc(w)}</li>`).join('')}
          </ul>
          <p class="sq__sizes">${esc(T('your_size'))} <b>${esc(T('top'))} ${esc(ans.sizes.top)}</b> · <b>${esc(T('bottom'))} ${esc(ans.sizes.bottom)}</b></p>
          ${styleOpt ? `<div class="sq__styles">${['Básica', 'Tanga'].filter((s) => styleOpt.values.some((v) => styleLabel(v) === s)).map((s) => `<button type="button" data-sq-style="${s}" aria-pressed="${style === s}">${esc(styleName(s))}${s === rec.rules.style ? ` <small>${esc(T('recommended'))}</small>` : ''}</button>`).join('')}</div>` : ''}
          <button type="button" class="sq__next sq__add" data-sq-add ${okAll ? '' : 'disabled'}>${okAll ? `${esc(T('add'))} · ${esc(money(total))}` : esc(T('sold_out_combo'))}</button>
          <a class="sq__link" href="${esc(url)}">${esc(T('see_product'))}</a>
        </div>
      </div>
      ${rec.picks.length > 1 ? `<p class="sq__kicker sq__kicker--alt">${esc(T('also'))}</p>
        <div class="sq__alts">${rec.picks.map((p, i) => (i === current ? '' : `<button type="button" data-sq-alt="${i}"><img src="${esc(img(p.items[0].p.img[0], 300))}" alt="" width="300" height="400" loading="lazy"><span>${esc(p.title)}</span><b>${esc(money(p.price))}</b></button>`)).join('')}</div>` : ''}
      <button type="button" class="sq__restart" data-sq-restart>${esc(T('restart'))}</button>`;
  }

  function computeSizes() {
    if (sizeMode === 'ropa') {
      const bra = $('[data-sq-bra]', modal).value, jeans = $('[data-sq-jeans]', modal).value;
      if (!bra || !jeans) { toast(T('need_clothes')); return null; }
      return { top: BRA[bra], bottom: JEANS[jeans] };
    }
    const v = (k) => Number($(`[data-sq-range="${k}"]`, modal).value);
    return { top: pickSize('pecho', v('pecho')), bottom: pickSize('cadera', v('cadera')) };
  }

  async function addToCart(pick) {
    const items = pick.items.map((it) => ({ id: it.variant[0], quantity: 1 }));
    try {
      const res = await fetch(`${ROOT}cart/add.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
      const json = await res.json();
      if (!res.ok) { toast(json.description || json.message || T('cart_error')); return; }
      const Cart = Qx().Cart;
      if (Cart) {
        await Cart.fetch();
        Cart.open();
        document.dispatchEvent(new CustomEvent('quelton:cart', { detail: Cart.data }));
      } else {
        window.location.href = `${ROOT}cart`;
      }
    } catch (e) { toast(T('cart_error')); }
  }

  let lastFocus = null;
  function go(n) { step = Math.max(0, Math.min(STEPS.length - 1, n)); render(); $('.sq__box', modal).scrollTop = 0; }
  function open(e) {
    if (e && e.preventDefault) e.preventDefault();
    lastFocus = document.activeElement;
    loadAll();
    modal.classList.add('is-open');
    document.body.classList.add('is-locked');
    render();
    setTimeout(() => { const c = $('.sq__close', modal); if (c) c.focus(); }, 50);
  }
  function close() {
    modal.classList.remove('is-open');
    if (!$('.drawer.is-open,.search-panel.is-open,.quiz.is-open')) document.body.classList.remove('is-locked');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  const toResult = () => { current = 0; styleChoice = null; go(STEPS.indexOf('resultado')); };

  modal.addEventListener('click', (e) => {
    if (e.target.closest('[data-sq-close]')) { close(); return; }
    if (e.target.closest('[data-sq-back]')) { go(step - 1); return; }
    const pick = e.target.closest('[data-sq-pick]');
    if (pick) {
      const key = pick.dataset.sqPick, list = { hair: HAIR, skin: SKIN, eyes: EYES, body: BODY }[key];
      ans[key] = list.find((o) => o.id === pick.dataset.id);
      $$(`[data-sq-pick="${key}"]`, modal).forEach((b) => b.setAttribute('aria-pressed', String(b === pick)));
      setTimeout(() => go(step + 1), reduceMotion ? 0 : 220);
      return;
    }
    const det = e.target.closest('[data-sq-detail]');
    if (det) {
      ans[det.dataset.sqDetail] = det.dataset.val;
      $$(`[data-sq-detail="${det.dataset.sqDetail}"]`, modal).forEach((b) => b.setAttribute('aria-pressed', String(b === det)));
      return;
    }
    if (e.target.closest('[data-sq-nextstep]')) { go(step + 1); return; }
    const mode = e.target.closest('[data-sq-mode]');
    if (mode) { sizeMode = mode.dataset.sqMode; render(); return; }
    if (e.target.closest('[data-sq-saved]')) { ans.sizes = Size.get(); toResult(); return; }
    if (e.target.closest('[data-sq-calc]')) { const s = computeSizes(); if (!s) return; ans.sizes = s; Size.set(s); toResult(); return; }
    const st = e.target.closest('[data-sq-style]');
    if (st) { styleChoice = st.dataset.sqStyle; render(); return; }
    const alt = e.target.closest('[data-sq-alt]');
    if (alt) { current = Number(alt.dataset.sqAlt); styleChoice = null; render(); $('.sq__box', modal).scrollTop = 0; return; }
    if (e.target.closest('[data-sq-restart]')) { ['hair', 'skin', 'eyes', 'body'].forEach((k) => delete ans[k]); go(0); return; }
    if (e.target.closest('[data-sq-add]')) {
      const pickNow = rec && rec.picks[current];
      if (!pickNow) return;
      close();
      addToCart(pickNow);
    }
  });
  modal.addEventListener('input', (e) => {
    const r = e.target.closest('[data-sq-range]');
    if (r) $(`[data-sq-out="${r.dataset.sqRange}"]`, modal).textContent = `${r.value} cm`;
    const es = e.target.closest('[data-sq-estilo]');
    if (es) {
      ans.estilo = Number(es.value);
      const lv = STYLE_LEVELS[ans.estilo - 1];
      es.style.setProperty('--p', `${(ans.estilo - 1) * 25}%`);
      $('[data-sq-estilo-label]', modal).textContent = lv.label;
      $('[data-sq-estilo-text]', modal).textContent = lv.text;
      $('[data-sq-estilo-ex]', modal).innerHTML = styleExamples(ans.estilo);
    }
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && modal.classList.contains('is-open')) close(); });

  // ---------- botón de abajo a la izquierda (no en las fichas de producto) ----------
  let dismissed = false;
  try { dismissed = Date.now() - Number(localStorage.getItem(KEY) || 0) < WEEK; } catch (e) { /* sin almacenamiento */ }
  const designMode = window.Shopify && window.Shopify.designMode;
  if (cfgEl.dataset.launcher !== 'false' && !dismissed && !designMode) {
    const launcher = document.createElement('div');
    launcher.className = 'sq-launch';
    launcher.innerHTML = `<button type="button" class="sq-launch__open" data-sq-open>
        <span class="sq-launch__spark" aria-hidden="true">✦</span><span><b>${esc(T('launcher_title'))}</b><small>${esc(T('launcher_sub'))}</small></span>
      </button>
      <button type="button" class="sq-launch__x" data-sq-dismiss aria-label="${esc(T('launcher_dismiss'))}">✕</button>`;
    document.body.appendChild(launcher);
    setTimeout(() => launcher.classList.add('is-in'), 1200);
    launcher.addEventListener('click', (e) => {
      if (e.target.closest('[data-sq-dismiss]')) {
        launcher.classList.remove('is-in');
        setTimeout(() => launcher.remove(), 400);
        try { localStorage.setItem(KEY, String(Date.now())); } catch (err) { /* sin almacenamiento */ }
        return;
      }
      if (e.target.closest('[data-sq-open]')) open();
    });
  }
  // cualquier enlace o botón con data-estilo-open abre el cuestionario (p. ej. desde el menú)
  document.addEventListener('click', (e) => { if (e.target.closest('[data-estilo-open]')) open(e); });
  window.QEstilo = { open, close };
})();
